var entornosAdminService = angular.module('entornosAdmin');

entornosAdminService.factory('entornosAdminService', ['$http', '$q', '__env', function entornosAdminService($http, $q, __env) {
        var serviceUrl = __env.apiUrl;
        var categoriasUrl = 'categorias';
        var rolesUrl = 'roles';

    function getEntornos() {
        return $http.get(serviceUrl + categoriasUrl + '/entornos');
        }

    function getEntorno(id) {
        return $http.get(serviceUrl + categoriasUrl + '/entornos/' + id);
        }

        function put(descripcion, id) {
            return $http({
                method: 'put',
                url: serviceUrl + categoriasUrl + '/editar/entornos/' + id,
                params:
                {
                    'entorno': descripcion
                }
            });
        }

    function post(entorno) {
            //return $http.post(serviceUrl + usuariosUrl + '/registrar/' + idRolUsuario, usuario);
            return $http({
                method: 'post',
                url: serviceUrl + categoriasUrl + '/registrar/entornos',
                params:
                {
                    'entorno': entorno
                }

            });
        }

        function obtenerPrimerErrorModelState(response) {
            var errores = [];
            for (var key in response.ModelState) {
                for (var i = 0; i < response.ModelState[key].length; i++) {
                    errores.push(response.ModelState[key][i]);
                }
            }
            return errores[0];
        }
    function eliminarEntornos(entornosEliminar) {
        return $http.post(serviceUrl + categoriasUrl + '/eliminarEntornos/' + entornosEliminar, { headers: { 'Content-Type': 'application/json' } }).catch(function (response) {
                alert('Error');
            });
        }



        return {
            getEntornos: getEntornos,
            getEntorno: getEntorno,
            put: put,
            post: post,
            obtenerPrimerErrorModelState: obtenerPrimerErrorModelState,
            eliminarEntornos: eliminarEntornos,


        }

    }]);